const CHUNK_RELOAD_STORAGE_KEY = 'cardify:chunk-reload-at';
const CHUNK_RELOAD_COOLDOWN_MS = 30 * 1000;

const CHUNK_LOAD_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk \d+ failed/i,
  /Unable to preload CSS/i,
];

const getErrorText = (error) => {
  if (!error) {
    return '';
  }

  if (typeof error === 'string') {
    return error;
  }

  const parts = [
    error.message,
    error.stack,
    error.reason?.message,
    error.reason?.stack,
    error.payload?.message,
    error.payload?.stack,
  ];

  return parts.filter(Boolean).join('\n');
};

const isAssetChunkUrl = (value) => {
  if (!value) {
    return false;
  }

  try {
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin &&
      /^\/assets\/.+\.(?:js|css)$/i.test(url.pathname);
  } catch {
    return /^\/assets\/.+\.(?:js|css)(?:\?|$)/i.test(value);
  }
};

export const isChunkLoadError = (error) => {
  const errorText = getErrorText(error);
  const assetUrl =
    error?.target?.src ||
    error?.target?.href ||
    error?.payload?.href;

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(errorText)) ||
    isAssetChunkUrl(assetUrl);
};

export const clearChunkReloadState = () => {
  try {
    window.sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
  } catch {
    // Ignore storage failures. The reload fallback still works without them.
  }
};

export const reloadOnChunkLoadError = (error) => {
  if (!isChunkLoadError(error)) {
    return false;
  }

  const now = Date.now();

  try {
    const lastReloadAt = Number(window.sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY) || 0);

    if (Number.isFinite(lastReloadAt) && now - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) {
      return false;
    }

    window.sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, String(now));
  } catch {
    // Continue with the reload even if sessionStorage is unavailable.
  }

  window.location.reload();
  return true;
};

export const setupChunkLoadErrorReload = () => {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadOnChunkLoadError(event.payload || event);
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (reloadOnChunkLoadError(event.reason || event)) {
      event.preventDefault();
    }
  });

  window.addEventListener(
    'error',
    (event) => {
      if (reloadOnChunkLoadError(event.error || event)) {
        event.preventDefault();
      }
    },
    true,
  );
};
